/**
 * Portal Manta · abrirParaImprimir
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';

function abrirParaImprimir(html, titulo) {
  const w = window.open('', '_blank', 'width=900,height=700');
  if (!w) { alert('Bloqueado pelo navegador. Permita pop-ups para este site.'); return; }
  w.document.write(html);
  w.document.close();
  w.document.title = titulo;
  setTimeout(() => { try { w.focus(); w.print(); } catch(e){} }, 400);
}

export { abrirParaImprimir };
export default abrirParaImprimir;
